import { Pipe, PipeTransform } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ShoppingCartState } from '../../actions/standalone';
import {
  selectFreePackage,
  selectPackagesInBasket,
  selectPackagesInShop,
} from '../../actions/selector';
import { map, switchMap } from 'rxjs/operators';
import { SuggestPackageAtBeginningService } from 'ZalamoLibrary/src/lib/ui/products/products-front/components/view-package/suggest-package-at-beginning.service';

@Pipe({
    name: 'packagePrice',
    standalone: false
})
export class PackagePricePipe implements PipeTransform {
  packageInShop$ = this.store.pipe(select(selectPackagesInShop));
  packageInBasket$ = this.store.pipe(select(selectPackagesInBasket));
  freePackage$ = this.store.pipe(select(selectFreePackage));

  constructor(
    private store: Store<{ shoppingCart: ShoppingCartState }>,
    private suggestFreePackage: SuggestPackageAtBeginningService
  ) {}

  transform(packageId: string, timeAddedToShoppingCart: number) {
    return this.packageInShop$.pipe(
      map(
        (packages) =>
          packages.package.find((current) => current.packageId === packageId)
            .price
      ),
      switchMap((prices) =>
        this.freePackage$.pipe(
          map((freePackage) => ({
            prices,
            freePackageId: freePackage.freePackageId,
          }))
        )
      ),
      switchMap(({ prices, freePackageId }) =>
        this.packageInBasket$.pipe(
          map((packageInBasket) => ({
            prices,
            freePackageId,
            timeAdded: packageInBasket.filter(
              (current) => current.packageId === packageId
            )?.[0]?.timeAddedToShoppingCart,
          }))
        )
      ),
      map(({ prices, freePackageId, timeAdded }) => {
        if (
          !this.suggestFreePackage.loadAlreadyOrdered() &&
          packageId === freePackageId &&
          timeAdded === timeAddedToShoppingCart
        ) {
          return null;
        } else {
          return prices;
        }
      })
    );
  }
}
